import script from "./MediaTileBand.vue?vue&type=script&lang=js"
export * from "./MediaTileBand.vue?vue&type=script&lang=js"

import "./MediaTileBand.vue?vue&type=style&index=0&id=3156d7e9&lang=scss"

const __exports__ = script;

export default __exports__